import React, { useState } from 'react';

interface Option {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

export interface DropdownProps {
  options: Option[];
  name?: string;
  value?: string;
  error?: any;
  selectedValue?: string;
  setSelectedValue?: (value: string) => void;
  showOptions?: boolean;
  setShowOptions?: (value: boolean) => void;
  setCategoryError?: (value: string) => void;
  placeholder?: string;
  onChange?: (name: string, value: string) => void;
  onFilter?: (value: string) => void;
  isSubmitted?: boolean;
  dropdownClassName?: string;
  iconClassName?: string;
  disabled?: boolean;
  className?: string; // This is the className for the input field
  label?: string;
  handlevariation?: (index: any, name: string, value: string) => void;
  variationIndex?: number;
}

const DropdownComponent: React.FC<DropdownProps> = ({
  name,
  options,
  value,
  error,
  placeholder,
  selectedValue,
  setSelectedValue,
  onChange,
  onFilter,
  isSubmitted,
  dropdownClassName,
  iconClassName,
  disabled,
  label,
  handlevariation,
  variationIndex,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  // Within the DropdownComponent:
  const iconContainerClassName = showOptions
    ? 'absolute top-0 right-0 mt-5 flex items-center'
    : 'absolute top-0 right-0 mt-5  flex items-center';
    const inputClassName = `block max-h-[48px] w-full min-h-[48px] border border-gray-300 border-opacity-50 placeholder:text-[16px] placeholder-gray-500 h-[px] rounded p-2 focus:border-[#138EFF] focus:outline-none ${
      error && !selectedValue ? 'ring-1 ring-red-500' : ''
    } ${dropdownClassName} ${selectedValue ? 'ring-1 ring-[#138EFF]' : ''}`;

  return (
    <div className="relative">
      <input
        className={inputClassName}
        value={label || selectedValue}
        placeholder={placeholder}
        // onClick={() => setShowOptions(!showOptions)}
        onClick={() => {
          if (!disabled) {
            setShowOptions(!showOptions);
            if (setSelectedValue) {
              setSelectedValue(value || '');
            }
          }
        }}
        readOnly
        disabled={disabled}
      />
      <div className={iconContainerClassName}>
        <svg
          className={`block fill-none ${iconClassName}`}
          width="12"
          height="10"
          viewBox="0 0 12 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <div></div>
          <path
            d="M5.18077 8.82967L0.541993 2.20285C-0.107529 1.27496 0.556286 -8.85647e-07 1.68892 -8.36138e-07L10.3111 -4.59251e-07C11.4437 -4.09742e-07 12.1075 1.27496 11.458 2.20285L6.81923 8.82967C6.42113 9.39839 5.57887 9.39838 5.18077 8.82967Z"
            fill="#A4A4A4"
          />
        </svg>
      </div>

      {showOptions && (
        <ul className={`z-50 absolute  bg-white  ${dropdownClassName}`}>
          {options.map((option) => (
            <li
              key={option.value}
              className="py-2 px-2 hover:bg-gray-200 cursor-pointer items-center font-light flex  focus:border-[#138EFF] focus:outline-none "
              onClick={() => {
                setShowOptions(false);
                if (setSelectedValue) {
                  setSelectedValue(option.value);
                }
                if (onChange) {
                  onChange(name || '', option.value);
                }
                if (onFilter) {
                  onFilter(option.value);
                }
                if (handlevariation) {
                  handlevariation(variationIndex, name || '', option.value);
                }
              }}
            >
              {option.icon && (
                <span className="mr-2">
                  <span className="icon-container inline-block align-middle ine-height-[1em] h-4 lg:w-4 lg:">
                    {option.icon}
                  </span>
                </span>
              )}
              <span>{option.label}</span>
            </li>
          ))}
        </ul>
      )}
      {isSubmitted && !selectedValue && error && <p className="text-red-500 text-sm absolute mt-[0.1em] ">{error}</p>}
    </div>
  );
};

export { DropdownComponent };
